import consumerApi from "api/services/consumer-api";
import logError from "utils/logError";

type Response = {
  status: number;
};

type Data = {
  form: string;
  is_private: boolean;
  language: string;
  rating: number;
  reported_benefits: string[];
  reported_feelings: string[];
  reported_flavors: string[];
  reported_negatives: string[];
  text: string;
};

const postStrainReview = async (
  slug: string,
  data: Data,
  countryCode: string
): Promise<Response> => {
  try {
    const response = await consumerApi.post(
      `/api/strain_reviews/v1/${slug}`,
      data,
      {
        headers: {
          "x-country-code": countryCode || "US",
        },
        timeout: 20000,
        withCredentials: true,
      }
    );

    return { status: response.status };
  } catch (e) {
    logError(e.message, {
      functionName: "postStrainReview",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return { status: 400 };
  }
};

export default postStrainReview;
